export const baseChartOptions = {
  credits: { enabled: false },
  title: { text: null },
};
